// extracted by mini-css-extract-plugin
module.exports = {"folder-list":"folder-list--1L-3Vo4vuA","folderList":"folder-list--1L-3Vo4vuA"};